import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import { ConfirmOverrideButton, DialogActionsStyled, DialogCancelButton } from './styled';
import { OverrideProviderConfirmDialogProps } from './types';

const OverrideProviderConfirmDialog = ({
  defaultProvider,
  onCancel,
  onConfirm,
  open,
  overrideProvider,
  state,
}: OverrideProviderConfirmDialogProps) => {
  return (
    <Dialog
      aria-describedby="override-provider-dialog-description"
      aria-labelledby="override-provider-dialog-title"
      fullWidth
      maxWidth="sm"
      onClose={onCancel}
      open={open}
      PaperProps={{ sx: { maxWidth: '560px', width: '100%' } }}
    >
      <DialogTitle
        id="override-provider-dialog-title"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}
      >
        Override MVR provider?
        <IconButton aria-label="close" onClick={onCancel} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="override-provider-dialog-description">
          The default provider for this state{state ? ` (${state})` : ''} is{' '}
          <strong>{defaultProvider || 'unknown'}</strong>. Are you sure you want to change it to{' '}
          <strong>{overrideProvider}</strong>?
        </DialogContentText>
      </DialogContent>

      <DialogActionsStyled>
        <DialogCancelButton onClick={onCancel}>Cancel</DialogCancelButton>
        <ConfirmOverrideButton onClick={onConfirm} variant="contained">
          Continue
        </ConfirmOverrideButton>
      </DialogActionsStyled>
    </Dialog>
  );
};

export default OverrideProviderConfirmDialog;
